import { IAppConfig } from "../types/common";

const apiUrl: string = process.env.REACT_APP_API_URL!;
const auth0Domain: string = process.env.REACT_APP_AUTH0_DOMAIN!;
const auth0ClientId: string = process.env.REACT_APP_AUTH0_CLIENTID!;
const auth0RedirectUri: string = process.env.REACT_APP_AUTH0_REDIRECTURI!;
const auth0Audience: string = process.env.REACT_APP_AUTH0_AUDIENCE!;

const appConfig: IAppConfig =
{
    API_URL: apiUrl,
    THEME_COLORS: {
        PRIMARY: "#007bff",
        SECONDARY: "#fc3"
    },
    AUTH0_DOMAIN: auth0Domain,
    AUTH0_CLIENTID: auth0ClientId,
    AUTH0_AUDIENCE: auth0Audience,
    AUTH0_REDIRECTURI: auth0RedirectUri
}

export { appConfig };